import React from 'react';
import {
  Select, Button, Radio,
} from 'antd';
import FilterBar from './FilterBar';
import ScenarioCompareDataView from './ScenarioCompareDataView';
import UseBktGrid from '../UseBktGrid';
import PageWithTopbar from '../PageWithTopbar';
import LoadSpinnerOverlay from '../LoadSpinner';
import {
  Label, ScrollableVHContainer, ShowAllButton, InOutSelect, DataTypeDropdown,
} from './styles';
import { Main } from '../ScenarioPage/styles';

// This function adds a row to show the delta between 2 compared scenarios.
const addDeltaRow = (data) => {
  const deltaRow = Object.keys(data[0]).reduce((p, c) => {
    if (typeof data[0][c] === 'number') {
      const showValue = parseFloat(data[1][c] - data[0][c]).toFixed(2);
      if (showValue !== 'NaN') {
        return {
          ...p,
          [c]: {
            customUI: 'useDeltaSymbol',
            value: showValue,
          },
        };
      }
    }
    return { ...p, [c]: '' };
  }, {});
  deltaRow.id = 3;

  return [...data, deltaRow];
};

const ScenarioCompareDrawer = ({
  weekDaySelect,
  startDate,
  inputOrOutput,
  dataType,
  downloadDataCompare,
  globalFilters,
  globalFilterApplied,
  kpiFilterApplied,
  onClickToChangeWeekDaySelect,
  onClickToChangeInputOutput,
  onClickToChangeDataType,
  onClickToChangeFilter,
  onClickToShowAllData,
  onClickToShowDataSummary,
  onClickToToggleFilterView,
  dataViewForKpis,
  dataViewForData,
  gridConfigForKpis,
  gridConfigForData,
  dataTypeOptions,
  dataCutOff,
  persistParams,
  onClickToViewScenario,
  title,
}) => {
  const loadingKpisCompare = dataViewForKpis.loadingQueue.length > 0;
  const loadingDataCompare = dataViewForData.loadingQueue.length > 0;
  const onGridRowSelect = ({ rowData: { id } }) => onClickToViewScenario({ id, fromDate: startDate }, true);
  return (
    <>
      <FilterBar
        weekStart={startDate}
        weekDaySelect={weekDaySelect}
        globalFilters={globalFilters}
        globalFilterApplied={globalFilterApplied}
        kpiFilterApplied={kpiFilterApplied}
        onClickToChangeWeekDaySelect={onClickToChangeWeekDaySelect}
        onClickToChangeFilter={onClickToChangeFilter}
        onClickToToggleFilterView={onClickToToggleFilterView}
        filterDisabled={loadingDataCompare}
        weekdayPickerDisabled={loadingDataCompare || loadingKpisCompare}
        persistParams={persistParams}
        title={title}
      />
      <Main height="200px">
        <LoadSpinnerOverlay
          spinning={loadingKpisCompare}
          height="140px"
        />
        {
          (
            !loadingKpisCompare
            && dataViewForKpis.data.data
          ) && (
            <>
              <UseBktGrid
                data={addDeltaRow(dataViewForKpis.data.data)}
                meta={dataViewForKpis.data.meta}
                config={gridConfigForKpis}
                onSelect={onGridRowSelect}
              />
              <InOutSelect
                value={inputOrOutput}
                onChange={onClickToChangeInputOutput}
                size="small"
              >
                <Radio.Button value="input">Input</Radio.Button>
                <Radio.Button value="output">Output</Radio.Button>
              </InOutSelect>
            </>
          )
        }
      </Main>
      <Main>
        <PageWithTopbar
          bg="greyscale.4"
          leftComponent={(
            <section>
              <DataTypeDropdown
                value={dataType}
                style={{ width: 210 }}
                onChange={onClickToChangeDataType}
                disabled={loadingDataCompare}
              >
                {
                  dataTypeOptions
                    .filter(({ is_child: isChild, data_group: dataGroup }) => !isChild && !(dataGroup === 'history'))
                    .sort((a, b) => a.item_display_name.localeCompare(b.item_display_name))
                    .map(item => (
                      <Select.Option key={item.item_type}>{item.item_display_name}</Select.Option>
                    ))
                }
              </DataTypeDropdown>
              <Button
                icon="download"
                onClick={downloadDataCompare}
              >
                XLSX
              </Button>
            </section>
          )}
          midComponent={(
            <Label py="2">Data Differences</Label>
          )}

          rightComponent={(
            <Button
              onClick={onClickToShowDataSummary}
            >
              Summary of all data
            </Button>
          )}
        >
          <ScrollableVHContainer>
            <LoadSpinnerOverlay
              width="100%"
              spinning={loadingDataCompare}
            />
            <ScenarioCompareDataView
              dataViewForData={dataViewForData}
              dataType={dataType}
              dataTypeOptions={dataTypeOptions}
              gridConfigForData={gridConfigForData}
            />
          </ScrollableVHContainer>
        </PageWithTopbar>
        <ShowAllButton
          type="primary"
          bg="clientSecondary"
          onClick={onClickToShowAllData}
          bottom={(
            dataCutOff && dataViewForData
            && !loadingDataCompare
          ) ? 0 : -50}
        >
          Cut off data is being displayed. Click here to show all results.
        </ShowAllButton>
      </Main>
    </>
  );
};


export default ScenarioCompareDrawer;
